import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import LoanChequePageUI from './LoanChequePageUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'

class LoanChequePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      loanChequeList: [],
      createMode: false,
      updateMode: false,
      selectedCheque: null,
      loading: true,
      docsUploadMode: false,
      uploadSubmitted: false,
      uploadSuccessMsg: null,
      uploadErrorList: [],
      fileDownloadSubmitted: false,
      fileErrorList: [],
      deleteSubmitted: false,
      deleteSuccessMsg: null,
      deleteErrorList: []
    }
  }

  render() {
    return (
      <LoanChequePageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        onRefreshClick={this.onRefreshClick}
        onCreateChequeClick={this.onCreateChequeClick}
        loanChequeList={this.state.loanChequeList}
        onEditChequeClick={this.onEditChequeClick}
        onDeleteChequeClick={this.onDeleteChequeClick}
        getStatusDisplayValue={this.getStatusDisplayValue}
        loading={this.state.loading}
        //
        docsUploadMode={this.state.docsUploadMode}
        onDocsUploadClick={this.onDocsUploadClick}
        onDocsUploadCancel={this.onDocsUploadCancel}
        onDocsUpload={this.onDocsUpload}
        //
        onDocDownloadClick={this.onDocDownloadClick}
        onFileDeleteClick={this.onFileDeleteClick}
        //
        createMode={this.state.createMode}
        updateMode={this.state.updateMode}
        selectedCheque={this.state.selectedCheque}
        onCancelChequeCreate={this.onCancelChequeCreate}
        onCancelChequeUpdate={this.onCancelChequeUpdate}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getLoanCheques(context)
  }

  getStatusDisplayValue = (statusKey) => {
    let closureStatusList = [
      { key: 'open', value: 'Open' },
      { key: 'close', value: 'Close' },
      { key: 'pending_for_closure', value: 'Pending For Closure' }
    ]
    const statusItem = closureStatusList.find(item => item.key === statusKey)
    return statusItem ? statusItem.value : statusKey
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  onDocsUploadClick = (event) => {
    let messageApprovalId = event.currentTarget.getAttribute('message-approval-id');
    this.setState({ docsUploadMode: true, selectedMessageId: messageApprovalId }, () => {
      // Log after state is updated
      console.log("selected id:", this.state.selectedMessageId);
    });
  }


  onDocsUpload = (fileId, fileName, fileType, fileSize) => {
    this.setState({
      uploadSubmitted: true,
      uploadSuccessMsg: null,
      uploadErrorList: [],
    });

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}/validation`,
      this.onDocsUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    });
  }

  onDocDownloadClick = (event) => {
    const loanId = event.currentTarget.getAttribute('data-loan-id');
    const fileName = event.currentTarget.getAttribute('data-file-name');

    this.setState({ fileDownloadSubmitted: true });

    RestApiUtils.get(
      this.props.context,
      `/api/su/loans/${loanId}/${fileName}/fileDownloadSignedUrl`,
      this.onDocDownloadClickCallback,
      null
    );
  };

  onDocDownloadClickCallback = (response) => {
    this.setState({
      fileDownloadSubmitted: false,
      fileErrorList: response.errorList
    });

    if (response.errorList.length === 0 && response.signedUrl && response.signedUrl.signedUrl) {
      const link = document.createElement('a');
      link.href = response.signedUrl.signedUrl;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  onFileDeleteClick = (event) => {
    if (this.state.deleteSubmitted) return;

    const fileName = event.currentTarget.getAttribute('data-file-name');
    const loanId = this.props.match.params.loanId;

    this.setState({
      deleteSubmitted: true,
      deleteErrorList: [],
      deleteSuccessMsg: null
    });

    RestApiUtils.delete(
      this.props.context,
      `/api/su/loans/${loanId}/files/${encodeURIComponent(fileName)}`,
      this.onFileDeleteCallback
    );
  };

  onFileDeleteCallback = (response) => {
    var errorList = (response.errorList && response.errorList.map(function (err) {
      return err.message;
    })) || [];

    this.setState({
      deleteSubmitted: false,
      deleteSuccessMsg: response.success,
      deleteErrorList: errorList
    });

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ deleteSuccessMsg: null, deleteErrorList: [] });
        this.onRefreshClick('noBusy');
      }, 2000);
    }
  };

  onDocsUploadCallback = (response) => {
    this.setState({ uploadSubmitted: false });
    let errorList = [];
    response.errorList.forEach(error => {
      errorList.push(error.message);
    });

    this.setState({
      uploadSuccessMsg: response.success,
      uploadErrorList: errorList,
    });

    this.onRefreshClick('noBusy');

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          uploadSuccessMsg: null
        });
      }, 2000);
    }
  }

  getLoanCheques = (context = this.props.context) => {
    this.setState({ loading: true })
    const loanId = this.props.match.params.loanId
    RestApiUtils.get(context,
      `/api/su/loans/${loanId}/chequeBounces`,
      this.getLoanChequesCallback
    )
  }

  getLoanChequesCallback = (response) => {
    this.setState({
      loanChequeList: response.chequeBounceList || [],
      errorList: response.errorList || [],
      loading: false
    })
  }

  onRefreshClick = () => {
    this.getLoanCheques()
  }

  onCreateChequeClick = () => {
    this.setState({ createMode: true })
  }

  onCancelChequeCreate = () => {
    this.setState({ createMode: false })
  }

  onEditChequeClick = (cheque) => {
    this.setState({
      updateMode: true,
      selectedCheque: cheque
    })
  }

  onCancelChequeUpdate = () => {
    this.setState({
      updateMode: false,
      selectedCheque: null
    })
  }

  onDeleteChequeClick = (cheque) => {
    const loanId = this.props.match.params.loanId
    const chequeId = cheque.chequeBounceId

    RestApiUtils.delete(this.props.context,
      `/api/su/loans/${loanId}/chequeBounces/${chequeId}`,
      (response) => {
        if (response.success) {
          this.getLoanCheques()
        } else {
          console.error("Failed to delete cheque bounce record", response.errorList)
        }
      }
    )
  }
}

export default withRouter(LoanChequePageSF)